import { HOST } from "../constants/HostConstants";
import { fetchWithCache, clearCache } from "../services/apiService";

export const propertyBulkStatusUpdate = async (
  propertyIds,
  newStatus,
  userId,
  callbacks
) => {
  try {
    const response = await fetch(
      `${HOST}/api/property/propertyBulkStatusUpdate`,
      {
        method: "POST",
        body: JSON.stringify({
          property_ids: propertyIds,
          property_status: newStatus,
          user_id: userId,
        }),
        credentials: "include",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server error: ${response.status} - ${errorText}`);
    }

    const data = await response.json();
    if (process.env.NODE_ENV !== "production") {
}

    // Clear cache since data has changed
    clearCache("/api/property/propertyByUser", { user_id: userId });
    clearCache("/api/property/allProperties");
    clearCache("/api/property/propertyActive");

    // Refresh the properties list with retry and cache support
    if (callbacks?.setProperties) {
      try {
        const propertiesData = await fetchWithCache(
          "/api/property/propertyByUser",
          {
            method: "POST",
            body: { user_id: userId },
            retries: 3,
            timeout: 15000,
          },
          true // force fresh fetch
        );
        callbacks.setProperties(propertiesData || []);
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
}
        // Optionally refresh after delay if API is waking up
        setTimeout(() => {
          fetchWithCache(
            "/api/property/propertyByUser",
            {
              method: "POST",
              body: { user_id: userId },
              retries: 2,
            },
            false
          ).then((data) => callbacks.setProperties(data || []));
        }, 2000);
      }
    }

    return data;
  } catch (error) {
    if (process.env.NODE_ENV !== "production") {
}
    throw error;
  }
};
